module.exports = __webpack_public_path__ + "img/81w.821713f.jpg";